<template>
  <v-card
    max-width="750"
    class="mx-auto"
    color="grey-lighten-3"
    :disabled="loading"
    :loading="loading"
  >
    <v-layout>
      <CustomAppBar :page="9" :title="$t('info_card.title_page9')" />
      <v-main>
        <v-card-text class="px-0 px-md-3 px-xl-6">
          <v-chip
            :color="isCompleteUploadDocument ? 'green' : 'red'"
            class="ml-3 mb-5"
          >
            <h2 class="mr-2">{{ $t("upload_doc.status") }}:</h2>
            <h2 v-if="isCompleteUploadDocument">
              {{ $t("upload_doc.uploaded") }}
            </h2>
            <h2 v-else>{{ $t("upload_doc.not_upload") }}</h2>
          </v-chip>

          <v-expansion-panels v-model="panel" class="mx-auto">
            <v-expansion-panel
              v-for="(item, index) in computedDocumentData"
              :key="index"
              @click="onExpansionPanelClick(index, item.DOCUMENT_TYPE_ID)"
            >
              <v-expansion-panel-title>
                <h5>
                  {{ index + 1 }}.
                  {{ objectTranslator(item, "DOCUMENT_TYPE_NAME") }}
                </h5>

                <v-chip color="black" v-if="item.REQUIRED == '1'">
                  <h6>{{ $t("upload_doc.required") }}</h6>
                </v-chip>
                <v-chip color="grey" variant="outlined" v-else>
                  <h6>{{ $t("upload_doc.optional") }}</h6>
                </v-chip>

                <v-chip
                  :color="getUploadStatusChipColor(item.UPLOAD_STATUS_ID)"
                  :append-icon="getUploadStatusChipIcon(item.UPLOAD_STATUS_ID)"
                  v-if="
                    item.REQUIRED === '1' ||
                    (item.REQUIRED === '0' && item.UPLOAD_STATUS_ID !== '1')
                  "
                >
                  <h6>{{ objectTranslator(item, "UPLOAD_STATUS_NAME") }}</h6>
                </v-chip>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pa-1 pa-sm-3">
                <p
                  class="bg-red-lighten-5 text-red mb-1"
                  v-if="item.COMMENT != '' && item.UPLOAD_STATUS_ID !== '3'"
                >
                  {{ $t("upload_doc.correction_details") }}:
                  <b>{{ item.COMMENT }}</b>
                </p>

                <v-row>
                  <v-col
                    cols="12"
                    v-for="(item, index) in currentFiles"
                    :key="index"
                  >
                    <v-card variant="outlined" elevation="0" class="pa-3">
                      <p>
                        {{ $t("upload.file") }}: {{ index + 1 }}/{{
                          currentFiles.length
                        }}
                      </p>

                      <a
                        :href="item.src"
                        target="_blank"
                        v-if="item.type == 'application/pdf'"
                      >
                        <v-btn
                          class="mb-1 float-right"
                          color="error"
                          variant="outlined"
                          prepend-icon="mdi-file-pdf-box"
                          elevation="0"
                        >
                          {{ $t("upload.view_file") }}
                        </v-btn>
                      </a>

                      <embed
                        :src="item.src"
                        width="100%"
                        height="500px"
                        type="application/pdf"
                        v-if="item.type == 'application/pdf'"
                      />

                      <PrimeVueImage :src="item.src" v-else />
                    </v-card>
                  </v-col>
                </v-row>

                <p
                  class="bg-red-lighten-5 text-red mb-1"
                  v-if="item.COMMENT != '' && item.UPLOAD_STATUS_ID !== '3'"
                >
                  {{ $t("upload_doc.correction_details") }}:
                  <b>{{ item.COMMENT }}</b>
                </p>

                <div v-if="!isLockedUpload && item.UPLOAD_STATUS_ID !== '3'">
                  <v-card class="rounded-0 pa-4 mt-5" variant="outlined">
                    <v-btn
                      prepend-icon="mdi-file-star-outline"
                      variant="outlined"
                      color="info"
                      :class="$vuetify.display.smAndUp ? 'mr-2' : 'mb-2'"
                      :block="$vuetify.display.xs"
                      :disabled="!item.EXAMPLE_FILEPATH"
                      :href="`https://www.reg.kmitl.ac.th/storage/kmitl1/example/${
                        this.surrogated_student_info.LEVEL_ID === '1'
                          ? 'undergraduate'
                          : 'graduate'
                      }/${item.EXAMPLE_FILEPATH}`"
                      target="_blank"
                    >
                      {{ $t("upload_doc.example_file") }}
                    </v-btn>
                    <v-btn
                      prepend-icon="mdi-file-download-outline"
                      variant="outlined"
                      color="info"
                      :class="$vuetify.display.smAndUp ? 'mr-2' : 'mb-2'"
                      :block="$vuetify.display.xs"
                      :disabled="!item.FORM_FILEPATH"
                      :href="`https://www.reg.kmitl.ac.th/storage/kmitl1/form/${
                        this.surrogated_student_info.LEVEL_ID === '1'
                          ? 'undergraduate'
                          : 'graduate'
                      }/${item.FORM_FILEPATH}`"
                      target="_blank"
                    >
                      {{ $t("upload_doc.download_form") }}
                    </v-btn>
                    <v-btn
                      prepend-icon="mdi-delete"
                      variant="outlined"
                      color="error"
                      :class="$vuetify.display.smAndUp ? 'mr-2' : 'mb-2'"
                      :block="$vuetify.display.xs"
                      :disabled="item.UPLOAD_STATUS_ID === '1'"
                      @click="deleteFiles"
                    >
                      {{ $t("upload_doc.delete_all_files") }}
                    </v-btn>
                  </v-card>

                  <v-card
                    class="rounded-0 pa-0 mt-5"
                    variant="outlined"
                    v-if="!isLockedUpload && item.UPLOAD_STATUS_ID !== '3'"
                  >
                    <PrimeVueUpload
                      accept="image/jpeg, image/png, application/pdf"
                      :fileLimit="5"
                      :callback="uploadFiles"
                      :key="item.DOCUMENT_TYPE_ID"
                    />
                  </v-card>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-divider></v-divider>
          <v-card-text
            ><div
              class="text-end mb-2 text-red"
              v-if="is_saved_before_page === false"
            >
              {{ $t("info.have_not_fill_page_before") }}
            </div>
            <div class="text-end">
              <v-btn color="primary" size="large" class="mr-2" to="/page8"
                >Back</v-btn
              >
              <v-btn
                color="primary"
                size="large"
                :disabled="is_saved_before_page === false"
                to="/main"
                >{{
                  isLockedUpload === true
                    ? "Main Page"
                    : "Save & Go to Main Page"
                }}</v-btn
              >
            </div></v-card-text
          >
        </v-card-text>
      </v-main>
    </v-layout>
  </v-card>
</template>

<script>
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import PrimeVueImage from "@/components/info_cards/PrimeVueImage.vue";
import PrimeVueUpload from "@/components/info_cards/PrimeVueUpload.vue";
import UserProvider from "@/services/user.provider";
import UploadProvider from "@/services/upload.provider";
import { objectTranslator } from "@/helper/translator";

const userService = new UserProvider();
const uploadProvider = new UploadProvider();

export default {
  name: "PageNine",

  components: {
    CustomAppBar,
    PrimeVueImage,
    PrimeVueUpload,
  },

  data: () => ({
    loading: false,
    panel: null,

    isCompleteUploadDocument: false,
    documentTypeData: [],
    documentData: [],

    currentDocumentTypeId: null,
    currentPageCount: null,
    currentFiles: [],

    is_saved_before_page: false,
  }),

  computed: {
    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    uploadStatuss() {
      return this.$store.state.ref.uploadStatuss;
    },

    isLockedUpload() {
      return (
        this.surrogated_student_info &&
        this.surrogated_student_info.LOCK_UPLOAD === "1"
      );
    },

    computedDocumentData() {
      return this.documentTypeData.map((item) => {
        let setted = false;

        this.documentData.map((item2) => {
          if (item.DOCUMENT_TYPE_ID === item2.DOCUMENT_TYPE_ID) {
            setted = true;
            item.UPLOAD_STATUS_ID = item2.UPLOAD_STATUS_ID;
            item.COMMENT = item2.COMMENT;
          }
        });

        if (setted === false) {
          item.UPLOAD_STATUS_ID = "1";
          item.COMMENT = "";
        }

        this.uploadStatuss.map((item2) => {
          if (item.UPLOAD_STATUS_ID === item2.UPLOAD_STATUS_ID) {
            item.UPLOAD_STATUS_NAME_TH = item2.UPLOAD_STATUS_NAME_TH;
            item.UPLOAD_STATUS_NAME_EN = item2.UPLOAD_STATUS_NAME_EN;
          }
        });

        return item;
      });
    },
  },

  methods: {
    objectTranslator,

    getUploadStatusChipColor(UPLOAD_STATUS_ID) {
      let color = "";
      switch (UPLOAD_STATUS_ID) {
        case "1":
          color = "black";
          break;
        case "2":
          color = "warning";
          break;
        case "3":
          color = "success";
          break;
        case "4":
          color = "error";
          break;
      }
      return color;
    },

    getUploadStatusChipIcon(UPLOAD_STATUS_ID) {
      let icon = "";
      switch (UPLOAD_STATUS_ID) {
        case "1":
          icon = null;
          break;
        case "2":
          icon = "mdi-clock-outline";
          break;
        case "3":
          icon = "mdi-check-circle-outline";
          break;
        case "4":
          icon = "mdi-close-circle";
          break;
      }
      return icon;
    },

    async fetchData() {
      this.loading = true;

      let data = await userService
        .getOverallUploadStatus(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (data) this.isCompleteUploadDocument = data.status;

      data = await uploadProvider
        .getDocumentType({ level_id: this.surrogated_student_info.LEVEL_ID })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (data) {
        if (this.surrogated_student_info.FACULTY_ID == '95') {
          this.documentTypeData = data.filter(item => item.DOCUMENT_TYPE_ID >= 951);
        } else {
          this.documentTypeData = data.filter(item => item.DOCUMENT_TYPE_ID < 951);
        }
      }
  
      data = await uploadProvider
        .getDocument({ uid: this.uid })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (data) this.documentData = data;

      this.loading = false;
    },

    onExpansionPanelClick(index, DOCUMENT_TYPE_ID) {
      if (this.panel != index) {
        this.clear();
        return;
      }

      if (this.currentDocumentTypeId === null) {
        this.currentDocumentTypeId = DOCUMENT_TYPE_ID;
        this.getFiles();
        return;
      }

      if (this.currentDocumentTypeId !== DOCUMENT_TYPE_ID) {
        this.clear();
        this.currentDocumentTypeId = DOCUMENT_TYPE_ID;
        this.getFiles();
        return;
      }
    },

    clear() {
      this.currentDocumentTypeId = null;
      this.currentPageCount = null;
      this.currentFiles.forEach((item) => {
        window.URL.revokeObjectURL(item);
      });
      this.currentFiles = [];
    },

    async getFiles() {
      this.loading = true;

      const data = await uploadProvider
        .getDocumentPages({
          uid: this.uid,
          DOCUMENT_TYPE_ID: this.currentDocumentTypeId,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (data && data.number) {
        this.currentPageCount = data.number;

        for (let i = 1; i <= this.currentPageCount; i++) {
          const data = await uploadProvider
            .getDocumentFile({
              uid: this.uid,
              DOCUMENT_TYPE_ID: this.currentDocumentTypeId,
              PAGE: i,
            })
            .catch((error) => {
              error.response.data.text().then((text) => {
                this.$toast.error(text);
              });
              this.loading = false;
            });
          if (data) {
            this.currentFiles.push({
              src: window.URL.createObjectURL(data),
              type: data.type,
            });
          }
        }
      }

      this.loading = false;
    },

    async uploadFiles(files) {
      this.loading = true;

      const currentDocumentTypeId = this.currentDocumentTypeId;

      const result = await uploadProvider
        .uploadDocument({
          uid: this.uid,
          DOCUMENT_TYPE_ID: this.currentDocumentTypeId,
          files: files,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (result && result.status === true) {
        this.$toast.success(this.$t("toast.upload_successfully"));
        this.clear();
        this.fetchData();
        this.currentDocumentTypeId = currentDocumentTypeId;
        this.getFiles();
      } else this.$toast.error(this.$t("toast.cannot_upload_file"));
    },

    async deleteFiles() {
      this.loading = true;

      const currentDocumentTypeId = this.currentDocumentTypeId;

      const data = await uploadProvider
        .deleteDocumentFile({
          uid: this.uid,
          DOCUMENT_TYPE_ID: this.currentDocumentTypeId,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (data && data.status === true) {
        this.$toast.success(this.$t("toast.delete_successfully"));
        this.clear();
        this.fetchData();
        this.currentDocumentTypeId = currentDocumentTypeId;
        this.getFiles();
      } else this.$toast.error(this.$t("toast.cannot_delete"));

      this.loading = false;
    },
  },

  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("7") &&
      this.surrogated_student_info.UPLOAD_STUDENT_CARD_PHOTO_STATUS === "1";

    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }

    this.$store.dispatch("ref/getUploadStatuss");
    this.fetchData();
  },
};
</script>

<style>
.v-expansion-panel-title {
  display: block !important;
}

.v-expansion-panel-title__icon {
  float: right;
}

.v-expansion-panel-text__wrapper {
  padding: 0px !important;
}

.v-chip {
  margin: 2px;
}
</style>
